import { Box } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { memo } from "react";
import { useAssetClassExtendedStat } from "./useAssetClassExtendedStat";
import { InternalUseWithDisclosures } from "../assetAllocation/editPortfolioGroup/InternalUse";
import { useChartDataSelector } from "../assetAllocation/editPortfolioGroup/useChartDataSelector";
import { ChartMultiPeriodReturnComparison } from "../assetAllocation/editPortfolioGroup/ChartMultiPeriodReturnComparison";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";
import { CarPageContent } from "@app/components/PageContent";
import { AssetClassLoadType } from "@app/features/assets/useAssetClasses";
import { CarDownloadButton } from "@app/components/Buttons";
import { openInNewTab } from "@app/utils";
import { assetClassAnalysisPages } from "@app/const/route.const";

export const AssetClassAnalysisMultiPeriodReturn = memo(() => {
  const pageContent = usePageContent();

  const data = useAssetClassExtendedStat({
    type: AssetClassLoadType.byLatestSimulationJob,
    filterByUsableInPortfolios: true,
  });

  const mprcItems = data.multiPeriodReturnComparison;
  const enabledMprcItems = mprcItems.filter((i) => !i.isDisabled);

  const chartDataSelector = useChartDataSelector({
    storageKey:
      "AssetClassAnalysisMultiPeriodReturnComparison_chartDataSelector",
    data1DefaultId: enabledMprcItems.at(0)?.id,
    data2DefaultId: enabledMprcItems.at(1)?.id,
  });

  const handleShowPdf = () => {
    if (chartDataSelector.data1Id) {
      openInNewTab(
        assetClassAnalysisPages.getPdfMultiPeriodReturnReportUrl({
          assetClass1Id: chartDataSelector.data1Id,
          assetClass2Id: chartDataSelector.data2Id ?? "",
        }),
      );
    }
  };

  return (
    <TablePlaceHolder
      isLoading={data.isLoading || pageContent.isLoading}
      rows={8}
    >
      <CarDownloadButton
        onClick={handleShowPdf}
        sx={{ mr: -1.5, alignSelf: "flex-end" }}
      >
        Download PDF
      </CarDownloadButton>

      <CarPageContent
        sx={{ mt: 1 }}
        isWhiteContext
        content={pageContent.getContent(
          CarPageContentCode.ASSET_CLASS_MONTHLY_REPORT_MULTI_PERIOD_RETURN_RETURN_REPORT,
        )}
      />
      <Box
        sx={{
          mt: 5,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: "gray3",
          py: 5,
          px: 12.5,
        }}
      >
        <InternalUseWithDisclosures />
        <ChartMultiPeriodReturnComparison
          selectorLabel1="Asset Class 1"
          selectorLabel2="Asset Class 2"
          data={mprcItems}
          chartDataSelector={chartDataSelector}
          isWhiteContext
          pendoPrefix="asset_class_analysis_multi_period_return_comparison"
        />
      </Box>
    </TablePlaceHolder>
  );
});
